import axios from 'axios';

const baseURL =
  process.env.RAILS_ENV === 'production'
    ? 'https://forms.txssc.txstate.edu'
    : process.env.RAILS_ENV === 'qual'
      ? 'https://forms.txssc.qual.txstate.edu'
      : 'http://localhost:3000';

const instance = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

instance.interceptors.request.use(
  function (config) {
    const csrfToken = document.getElementsByName('csrf-token')[0].content;
    config.headers['X-CSRF-Token'] = csrfToken;
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    return config;
  },
  function (error) {
    // Do something with request error
    console.log('high level error', error);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    response['ok'] = true;
    return response;
  },
  function (error) {
    error['errors'] = error.response?.data?.errors;
    error['data'] = error.response?.data;
    error['status'] = error.response?.status;
    return Promise.reject(error);
  }
);
export default instance;
